if (!customElements.get('ffn-product-discovery')) {
  customElements.define('ffn-product-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.rail = this.querySelector('[data-discovery-rail]');
      this.status = this.querySelector('[data-discovery-status]');
      // Energy moves dialogs to body. Keep complete markup in the initial cache.
      this.rail.querySelectorAll('modal-opener').forEach(opener => {
        const modal = document.querySelector(opener.dataset.modal);
        if (modal && !this.rail.contains(modal)) opener.parentElement.appendChild(modal);
      });
      this.cache = new Map([['featured', this.rail.innerHTML]]);
      this.rail.querySelectorAll('quick-add-modal').forEach(modal => document.body.appendChild(modal));
      this.active = 'featured';
      this.motion = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      this.addEventListener('click', (event) => {
        const filter = event.target.closest('[data-discovery-filter]');
        if (filter && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
          event.preventDefault();
          this.select(filter.dataset.discoveryFilter);
        }
        const step = event.target.closest('[data-discovery-step]');
        if (step) this.rail.scrollBy({left: Number(step.dataset.discoveryStep) * this.rail.clientWidth * .85, behavior: this.motion});
        const choose = event.target.closest('[data-discovery-choose]');
        if (choose) choose.closest('[data-discovery-card]').querySelector('modal-opener button')?.click();
      });
      this.rail.addEventListener('scroll', () => this.updatePosition(), {passive:true});
      this.resize = new ResizeObserver(() => this.updatePosition());
      this.resize.observe(this.rail);
      this.updatePosition();
    }
    disconnectedCallback() { this.request?.abort(); this.resize?.disconnect(); this.ready = false; }
    async select(key) {
      this.request?.abort();
      this.request = new AbortController();
      const request = this.request;
      this.status.textContent = this.dataset.loading;
      this.rail.setAttribute('aria-busy', 'true');
      try {
        if (!this.cache.has(key)) {
          const url = new URL(this.dataset.collection, location.origin);
          url.searchParams.set('section_id', 'ffn-discovery-results');
          url.searchParams.set('sort_by', key === 'sale' ? 'manual' : key);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, {signal:request.signal});
          if (!response.ok) throw new Error('Discovery response failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const results = doc.querySelector('[data-discovery-results]');
          if (!results) throw new Error('Discovery results missing');
          if (key === 'sale') results.querySelectorAll('[data-discovery-card]:not([data-sale="true"])').forEach(card => card.remove());
          this.cache.set(key, results.innerHTML);
        }
        if (request.signal.aborted) return;
        document.querySelectorAll('quick-add-modal[id^="QuickAdd-Discovery-"]').forEach(modal => modal.remove());
        this.rail.innerHTML = this.cache.get(key);
        this.rail.scrollLeft = 0;
        this.active = key;
        this.querySelectorAll('[data-discovery-filter]').forEach(control => {
          const selected = control.dataset.discoveryFilter === key;
          control.classList.toggle('is-active', selected);
          if (control.tagName === 'BUTTON') control.setAttribute('aria-pressed', String(selected));
          else if (selected) control.setAttribute('aria-current','true');
          else control.removeAttribute('aria-current');
        });
        const label = this.querySelector(`[data-discovery-filter="${key}"]`).textContent.trim();
        this.rail.setAttribute('aria-label', label);
        this.status.textContent = this.rail.querySelector('[data-discovery-card]') ? label : this.dataset.empty;
        this.updatePosition();
      } catch(error) {
        if (error.name !== 'AbortError') this.status.textContent = this.dataset.error;
      } finally {
        if (request === this.request) this.rail.removeAttribute('aria-busy');
      }
    }
    updatePosition() {
      const cards = [...this.rail.querySelectorAll('[data-discovery-card]')];
      const frame = this.rail.getBoundingClientRect();
      const visible = cards.map((card,index)=>({index,rect:card.getBoundingClientRect()})).filter(({rect})=>rect.right > frame.left + 10 && rect.left < frame.right - 10);
      this.querySelector('[data-discovery-position]').textContent = visible.length ? `${String(visible[0].index+1).padStart(2,'0')} — ${String(visible.at(-1).index+1).padStart(2,'0')} / ${String(cards.length).padStart(2,'0')}` : '';
      this.querySelector('[data-discovery-step="-1"]').disabled = this.rail.scrollLeft < 5;
      this.querySelector('[data-discovery-step="1"]').disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 5;
    }
  });
}
if (!window.ffnShopImageBound) {
  window.ffnShopImageBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pack-shop]');
    if (!button) return;
    const details = button.closest('[data-pack-panel]').querySelector('.ffn-starter-details');
    if (!details) return;
    details.open = true;
    details.querySelector('summary').focus({preventScroll:true});
    details.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant':'smooth',block:'center'});
  });
}

if (!customElements.get('ffn-routine')) {
  customElements.define('ffn-routine', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.tabs = [...this.querySelectorAll('[data-routine-target]')];
      this.panels = [...this.querySelectorAll('[data-routine-panel]')];
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-routine-target]');
        if (tab) this.select(tab);
        const hotspot = event.target.closest('[data-routine-hotspot]');
        if (hotspot) {
          const checkbox = hotspot.closest('[data-routine-panel]').querySelector('[data-routine-extra]');
          if (checkbox) { checkbox.checked = !checkbox.checked; checkbox.dispatchEvent(new Event('change', {bubbles:true})); }
        }
      });
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-routine-target]');
        if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        let next = this.tabs.indexOf(tab) + (event.key === 'ArrowLeft' ? -1 : 1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        const target = this.tabs[(next + this.tabs.length) % this.tabs.length];
        this.select(target); target.focus();
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-routine-extra]')) return;
        const form = event.target.closest('form');
        form.querySelector('[data-routine-extra-quantity]').disabled = !event.target.checked;
        form.querySelector('[data-routine-total]').textContent = event.target.checked ? form.dataset.combo : form.dataset.base;
        form.querySelector('.ffn-routine-extra').classList.toggle('is-selected',event.target.checked);
        form.closest('[data-routine-panel]').querySelector('[data-routine-hotspot]')?.setAttribute('aria-pressed',String(event.target.checked));
      });
    }
    select(tab) {
      this.tabs.forEach(control => {
        const active = control === tab;
        control.setAttribute('aria-selected', String(active));
        control.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => {
        const active = panel.dataset.routinePanel === tab.dataset.routineTarget;
        panel.hidden = !active;
        panel.toggleAttribute('inert',!active);
        if (active && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          panel.querySelector('.ffn-routine-stage')?.animate([{opacity:.3,translate:'24px 0'},{opacity:1,translate:'0 0'}],{duration:450,easing:'cubic-bezier(.2,.7,.2,1)'});
        }
      });
    }
  });
}
